import { useState } from "react"
import { useStarInfoListQuery, type StarInfoRequest } from "@/service/api/info"
import Bottom from "./components/Bottom"
import Feed from "./components/feed/Feed"
import Gallery from "./components/gallery/Gallery"
import Header from "./components/Header"
import News from "./components/news/News"
import Profile from "./components/Profile"
import Video from "./components/video/Video"
import FanChatButton from "./components/FanChatButton"
import Information from "./components/information/Information"
import { STAR_ID } from "@/shared/constants/star"

const Main = () => {
  const [starInfoRequest, setStarInfoRequest] = useState<StarInfoRequest>({
    Language: "en",
    requestDto: { starId: STAR_ID },
  })

  const { data: starInfo } = useStarInfoListQuery(starInfoRequest)

  return (
    <>
      <Header />
      <Profile starInfo={starInfo} />
      <News />
      <Feed starAngkorId={starInfo?.starAngkorId} />
      <Gallery />
      <Video />
      <Information starInfo={starInfo} />
      <Bottom starInfo={starInfo} />
      <FanChatButton starId={starInfo?.id} />
    </>
  )
}

export default Main
